// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Raleway_481732', '__Raleway_Fallback_481732'","fontStyle":"normal"},"className":"__className_481732","variable":"__variable_481732"};